module.exports = __webpack_public_path__ + "img/VERS3.b7990c8c.png";